/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useState, useRef, useEffect } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { NewsPapers } from 'components/newspapers'
import { Link } from '@ta-interaktiv/contentbricks'
import { CSSTransition } from 'react-transition-group'
import { data } from '../data.tsx'
import { Scrollama, Step } from 'react-scrollama'

// TODO Set the correct article ID here
const ARTICLE_ID = '743033646250'
const isMobile = window.innerWidth < 800

export function AppComponent() {
  const [currentStepIndex, setCurrentStepIndex] = useState(null)
  const [selected, setSelected] = useState(null)
  const [showInfoLayer, setShowInfoLayer] = useState(false)

  const currentData = data.find(d => d.id === currentStepIndex)
  const progressionBar = useRef(null)
  console.log(currentData)

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (progressionBar || progressionBar.current) {
        progressionBar.current.style.width = `${(window.scrollY /
          document.body.scrollHeight) *
          100}%`
      }
    })
  })

  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>Les archives de la «Tribune»</h1>
            <h2>
              Le premier volet des archives de la Tribune de Genève est
              désormais accessible en ligne. De la création du journal en 1879
              jusqu'à 1920,{' '}
              <Link href='https://www.e-newspaperarchives.ch/?l=fr'>
                consultez gratuitement
              </Link>{' '}
              les 41 premières années de la Julie. Retrouvez dans notre tutoriel
              vidéo les étapes pour découvrir les origines du journal.
            </h2>
          </div>
        </div>
      </header>

      <div className='main-text'>
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>La rédaction</div>
              <div className='ta updated'>Actualisé le 20 février 2021</div>
            </div>
            <p className='ta text'>
              Il s'agit de la première étape d'un travail de numérisation
              réalisé en Suisse, suivi de l’envoi de ce matériel vers des
              services spécialisés à l’étranger, chargés d’organiser cette
              matière aux fins de consultation en ligne par tout un chacun. Un
              pas de géant a été fait depuis les premiers balbutiements de ce
              projet pharaonique qui concerne à terme la «Tribune» jusqu’en 2013
              et deux autres titres genevois dans leur intégralité: «Le
              Courrier» et «La Suisse». En chiffres, cela correspond à 516’000
              pages pour «Le Courrier», 1’156’000 pages pour la «Tribune de
              Genève» et 814’000 pages pour «La Suisse». Tout sera terminé en
              2024.
            </p>
            <p className='ta text'>
              À cette occasion, nous vous proposons de revenir en compagnie
              d’experts, sur les thématiques fortes et événements marquants qui
              ont fait l’histoire du journal. Sans oublier les anecdotes et
              autres détails surprenants qui vous apporteront une vision plus
              claire de ce qu'était la presse à l'époque.
            </p>
          </div>
        </div>
      </div>

      {currentStepIndex >= 1 && currentStepIndex < 99 && (
        <div className='progression'>
          <div className='bar' ref={progressionBar} />
        </div>
      )}

      <Scrollama
        onStepEnter={data => {
          setCurrentStepIndex(data.data)
        }}
        onStepExit={data => {
          if (data.data === 0 && data.direction === 'up') {
            setCurrentStepIndex(-1)
          }
        }}
      >
        <Step data={0}>
          <div className='stage' style={{ height: '100vh' }} />
        </Step>
        {data.map(d => (
          <Step key={d.id} data={d.id}>
            <div className='stage' style={{ height: '100vh' }} />
          </Step>
        ))}
        <Step data={99}>
          <div className='stage' style={{ height: '80vh' }} />
        </Step>
      </Scrollama>

      <CSSTransition
        unmountOnExit
        in={showInfoLayer}
        timeout={500}
        classNames='info-layer-container'
      >
        {currentData && (
          <div
            className={`info-layer ${
              currentData.color === 'yellow' ? 'colored' : ''
            }`}
            onClick={() => {
              setShowInfoLayer(false)
              setSelected(null)
              document.body.classList.remove('freeze')
            }}
          >
            <div className='info-header'>
              <div className='close-inp'>
                <i className='ui icon chevron left' />
                Retour
              </div>
            </div>
            <div className='ui vertical segment'>
              <div className='ui text container ta'>{currentData.html}</div>
            </div>
          </div>
        )}
      </CSSTransition>

      <CSSTransition
        unmountOnExit
        in={(currentData && !currentData.title) || currentStepIndex === 0}
        timeout={500}
        classNames='scroll-layer-container'
      >
        <div className='scroll-layer'>
          <div>Continuez à scroller...</div>
        </div>
      </CSSTransition>

      <CSSTransition
        unmountOnExit
        in={currentData && currentData.title}
        timeout={500}
        classNames='newspapers-info-layer-container'
      >
        <div
          className='newspapers-info-layer'
          onClick={() => {
            console.log('CLICK')
            if (currentData && !currentData.link) {
              setSelected(currentStepIndex)
              document.body.classList.add('freeze')
              setTimeout(() => {
                setShowInfoLayer(true)
              }, 1000)
            }
          }}
        >
          <div className='text'>
            <div className='content'>
              {currentData && currentData.link && (
                <div className='abo-title'>
                  <span className='abo-chip'>ABO</span>
                </div>
              )}
              <div className='title'>{currentData && currentData.title}</div>
              <div className='description'>
                {currentData && currentData.description}
              </div>
              {currentData && currentData.link ? (
                <div className='action'>
                  <a
                    href={`https://www.tdg.ch/${currentData.link}`}
                    target='_blank'
                    rel='noreferrer'
                    className='cbLink cB'
                  >
                    <i className='icon external-link' />
                    Lire ce contenu
                  </a>
                </div>
              ) : (
                <div className='action'>
                  <span className='pseudolink'>
                    <i className='icon file alternate' />
                    Lire ce contenu
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </CSSTransition>

      <NewsPapers stage={currentStepIndex} selected={selected} data={data} />

      <div className='main-text'>
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <h4 className='ta text'>Une mémoire qui repose en paix</h4>
            <p className='ta text'>
              La Bibliothèque de Genève (BGE) met en œuvre cette numérisation en
              étroite collaboration avec la Bibliothèque nationale suisse (BNS)
              à Berne. Les deux institutions ont évidemment le plein accord des
              propriétaires des titres, Tamedia pour la «Tribune de Genève» et
              «La Suisse», et la Nouvelle Association du Courrier pour le
              quotidien du même nom. Et rien n’aurait été possible sans
              l’Association pour la numérisation des journaux patrimoniaux
              genevois (ANJG), fondée tout exprès pour contribuer au financement
              du projet. Martine Brunschwig Graf, ancienne conseillère d’État
              genevoise, a accepté d’en être la présidente.
            </p>
            <div className='embed-container'>
              <iframe
                src='https://www.youtube.com/embed/hJSYC3TNgO8'
                frameBorder='0'
              />
            </div>
            <p className='ta text'>
              La consultation de la «Tribune» de 1879 à 1920 se trouve sous
              <Link href='https://www.e-newspaperarchives.ch'>
                www.e-newspaperarchives.ch
              </Link>
              , un lien précieux que la BGE fournit évidemment dans le carnet à
              anneaux qu’elle vient d’éditer sous le titre «Outils numériques».
              Son directeur, Frédéric Sardet, avait l’intention de grouper
              plusieurs annonces durant le mois de novembre 2020, mais la
              fermeture de la BGE pour cause de crise sanitaire a contrarié ses
              projets.
            </p>
          </div>
        </div>
      </div>

      {/* <div className='ui vertical segment'>
        <div className='ui container'>
          <ArticleTeasers
            numberOfCards='three'
            articleIds={[31055163, 592935159204]}
          />
        </div>
              </div> */}

      <Footer
        mailTo='frederic.thomasset@tdg.ch'
        hidePortfolioTeaser
        locale='fr'
        articleId={ARTICLE_ID}
        credits={[
          [
            'Textes',
            'Benjamin Chaix, Cécile Denayrouse, Lorraine Fasler et Frédéric Thomasset'
          ],
          ['Conception et réalisation', 'Mathieu Rudaz']
        ]}
      />
    </div>
  )
}
